import { createSlice } from '@reduxjs/toolkit';

import { Establishment } from 'entities/Establishment';
import { AppError } from 'entities/Errors';

import { getEstablishmentList } from './establishment.action';

interface EstablishmentState {
  loading: boolean;
  error: null | AppError;
  establishments: Establishment[];
}

const initialState = {
  loading: false,
  error: null,
  establishments: [],
} as EstablishmentState;

export const establishmentSlice = createSlice({
  name: 'establishment',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getEstablishmentList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEstablishmentList.fulfilled, (state, action) => {
        state.loading = false;
        state.establishments = action.payload.data;
      })
      .addCase(getEstablishmentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as AppError;
      });
  },
});

export default establishmentSlice.reducer;
